import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComProductDealerModel } from 'src/app/model/com-product-dealer.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductDealerService } from 'src/oldApp/services/com-product-dealer.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';

@Component({
  selector: 'app-modal-sc-product-dealer',
  templateUrl: './modal-sc-product-dealer.component.html',
  styleUrls: ['./modal-sc-product-dealer.component.css']
})
export class ModalScProductDealerComponent implements OnInit {
  @Input() dealer:ComProductDealerModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public productCOECatalog:HMGenericCatalog[]=[];
  public dealerCatalog:CatalogModel[]=[];
  public paymentTypeCatalog:CatalogModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private comProductDealerService:ComProductDealerService,
    private employeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private modalService: NgbModal,
    private toastr:ToastrService,
    private utils:UtilitiesService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updateEmployeeJob=()=> {}
  updateProductCOE=()=> {}
  updateDealer=()=> {}
  updatePaymentType=()=> {}
  updateCommission=e=> this.dealer.commission=Number(e);
  updateCommissionShared=e=> this.dealer.commissionShared=Number(e);
  toggleActive=()=> this.dealer.activeId=!this.dealer.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.productCOEError()) errors.push('Necesita seleccionar un producto.');
    if(this.dealerError()) errors.push('Necesita seleccionar un convenio.');
    if(this.paymentTypeError()) errors.push('Necesita seleccionar un plazo.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(this.commissionSharedError()) errors.push('Necesita capturar una comisión compartida.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comProductDealerService.save(this.dealer)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  employeeJobError=()=> !this.dealer.employeeJobId;
  productCOEError=()=> !this.dealer.productosCOEId;
  dealerError=()=> !this.dealer.dealerId;
  paymentTypeError=()=> !this.dealer.paymentId;
  commissionError=()=> this.dealer.commission==0 || !this.dealer.commission;
  commissionSharedError=()=> this.dealer.commissionShared==0 || !this.dealer.commissionShared;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.employeeJobService.catalog(),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
      this.vwCommissionConfiguratorService.getAfiliates(),
      this.vwCommissionConfiguratorService.getPayments()
    )
    .pipe(
      tap(([empJobResp, productosResp, dealerResp, paymentResp]:[any, any, any, any])=> {
        if(empJobResp && productosResp && dealerResp && paymentResp) {
          this.employeeJobCatalog=empJobResp.data;
          this.productCOECatalog=productosResp.data.sort(this.utils.sortBy('description'));
          this.dealerCatalog=dealerResp.data.sort(this.utils.sortBy('description'));
          let plaz:number[]=[1,4,7,10,12];
          this.paymentTypeCatalog=paymentResp.data.filter(t=> plaz.includes(t.id));
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}
